import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import useI18n from "../hooks/useI18n";

const messages = defineMessages({
    fi: {
        id: "Suomi",
        defaultMessage: "Suomi"
    },
    se: {
        id: "Svenska",
        defaultMessage: "Svenska"
    },
    en: {
        id: "English",
        defaultMessage: "English"
    },
    no: {
        id: "Norsk",
        defaultMessage: "Norsk"
    }
});

const MenuLocaleSelect = (props) => {
    const { getLocale, getLanguages, setLocale } = useI18n();
    const [currentLocale, setCurrentLocale] = useState(getLocale());
    const lng = props.intl.formatMessage;

    /**
     * Switch the language and reload the page.
     * @param {string} locale
     */
    const switchLang = (locale) => {
        setCurrentLocale(locale);
        setLocale(locale);
        window.location.reload();
    }

    return (
        <Dropdown className="locale-select">
            <Dropdown.Toggle className="actionlist-button" variant='tertiary-menu'>
                {lng(messages[currentLocale])}
            </Dropdown.Toggle>
            <Dropdown.Menu className="custom-locale-menu">
                {getLanguages().map(locale => (
                    <Dropdown.Item
                        key={locale}
                        className={'dropdown-check-item' + (locale === currentLocale ? ' active' : '')}
                        onClick={() => { switchLang(locale); }}
                    >
                        {lng(messages[locale])}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    )
}

MenuLocaleSelect.propTypes = {
    'intl': PropTypes.object.isRequired
};

export default injectIntl(MenuLocaleSelect);
